import { resolveRebateModel } from "../../lib/formatter";
import { CellWithTooltip } from "./CellWithTooltip";

interface Props {
  rebateModelCode: string | null | undefined;
  isTopLevel: boolean;
  truncate?: boolean;
}

export const RebateModelCell = ({
  rebateModelCode,
  isTopLevel,
  truncate,
}: Props) => {
  const rebateModel = resolveRebateModel(rebateModelCode);
  const code = rebateModel.code ?? "";

  const value = isTopLevel
    ? [code, "(Top level)"].filter(Boolean).join(" ")
    : code;
  const tooltipLabel = isTopLevel
    ? `${rebateModel.description} (Top level)`
    : rebateModel.description;

  return (
    <CellWithTooltip
      tooltipLabel={tooltipLabel}
      value={value}
      truncate={truncate}
    />
  );
};
